import React from "react";
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme =>({
    root: {
        '& a': {
            color: theme.palette.primary.main,
            textDecoration: "none",
            "&:hover": {
                textDecoration: "underline",
            }
        },
    },
}));

export default function HTMLContent({ children, html, rootElement = "div", ...props }) {
    const classes = useStyles();

    const rootProps = {
        ...props,
        className: classes.root + ' ' + props.className,
        dangerouslySetInnerHTML: {
            __html: html ?? children, 
        },
    }

    const RootElement = rootElement;
    return (
        <RootElement {...rootProps} style={{whiteSpace: 'pre-wrap'}} />
    );
}